/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Security_ReviewInputs */

const en_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security review`)
};

const ar_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مراجعة أمنية`)
};

const bn_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিরাপত্তা পর্যালোচনা`)
};

const de_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheitsprüfung`)
};

const es_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisión de seguridad`)
};

const fr_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revue de sécurité`)
};

const pt_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisão de segurança`)
};

const zh_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全审查`)
};

const tr_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güvenlik incelemesi`)
};

const ru_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка безопасности`)
};

const pl_svchip_security_review = /** @type {(inputs: Svchip_Security_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd bezpieczeństwa`)
};

/**
* | output |
* | --- |
* | "Security review" |
*
* @param {Svchip_Security_ReviewInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_security_review = /** @type {((inputs?: Svchip_Security_ReviewInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Security_ReviewInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_security_review(inputs)
	if (locale === "bn") return bn_svchip_security_review(inputs)
	if (locale === "de") return de_svchip_security_review(inputs)
	if (locale === "es") return es_svchip_security_review(inputs)
	if (locale === "fr") return fr_svchip_security_review(inputs)
	if (locale === "pt") return pt_svchip_security_review(inputs)
	if (locale === "zh") return zh_svchip_security_review(inputs)
	if (locale === "tr") return tr_svchip_security_review(inputs)
	if (locale === "ru") return ru_svchip_security_review(inputs)
	if (locale === "pl") return pl_svchip_security_review(inputs)
	return en_svchip_security_review(inputs)
});